import { styled, TextField } from "@mui/material";

export const CustomTextField = styled(TextField)({
    '& .MuiInputBase-input': {
        fontSize: '0.875rem',
        color: 'black', // Input text color
    },
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'white',
        '& fieldset': {
            borderColor: 'gray',
        },
        '&:hover fieldset': {
            borderColor: 'gray',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'darkgray',
        },
    },
    '& .MuiInputLabel-root': {
        color: 'black !important', // Force label color to black
        '&.Mui-focused': {
            color: 'black !important', // Force focused label color to black
        },
    },
});